import { Injectable } from "@angular/core";
import { ApiService } from "../http/api.service";
import { apiPath } from "../../shared/api-path.const";
import { PageQuery, toPageQuery } from "../http/pagination.utils";
import {
  AdminAdjustPointsRequest,
  BalanceResponse,
  TransactionHistoryResponse,
  TransactionResponse,
} from "./rewards.interface";

@Injectable({
  providedIn: "root",
})
export class RewardsService {
  constructor(private readonly apiService: ApiService) {}

  public async getMyBalance(): Promise<BalanceResponse> {
    return this.apiService.sendGetRequest<BalanceResponse, undefined>(`${apiPath.rewards}/balance`, undefined);
  }

  public async getMyTransactions(first: number = 50, offset: number = 0): Promise<TransactionHistoryResponse> {
    return this.apiService.sendGetRequest<TransactionHistoryResponse, PageQuery>(
      `${apiPath.rewards}/transactions`,
      toPageQuery({ first, offset }),
    );
  }

  public async getBalanceForUser(userId: string): Promise<BalanceResponse> {
    return this.apiService.sendGetRequest<BalanceResponse, undefined>(
      `${apiPath.rewards}/balance/${userId}`,
      undefined,
    );
  }

  public async getTransactionsForUser(
    userId: string,
    first: number = 50,
    offset: number = 0,
  ): Promise<TransactionHistoryResponse> {
    return this.apiService.sendGetRequest<TransactionHistoryResponse, PageQuery>(
      `${apiPath.rewards}/transactions/${userId}`,
      toPageQuery({ first, offset }),
    );
  }

  public async increasePoints(userId: string, amount: number, description: string): Promise<TransactionResponse> {
    const body: AdminAdjustPointsRequest = {
      userId,
      amount,
      description,
    };

    return this.apiService.sendPostRequest<AdminAdjustPointsRequest, TransactionResponse>(
      `${apiPath.rewards}/increase`,
      body,
    );
  }

  public async decreasePoints(userId: string, amount: number, description: string): Promise<TransactionResponse> {
    const body: AdminAdjustPointsRequest = {
      userId,
      amount,
      description,
    };

    return this.apiService.sendPostRequest<AdminAdjustPointsRequest, TransactionResponse>(
      `${apiPath.rewards}/decrease`,
      body,
    );
  }

  public async syncHistoricalPayments(): Promise<void> {
    return this.apiService.sendPostRequest<undefined, void>(`${apiPath.rewards}/sync-historical`, undefined);
  }
}
